enum HouseholdsRoutes {
  List = '/households',
  Add = '/households/add',
  Edit = '/households/edit/:id',
}

export default HouseholdsRoutes
